import { SET_JOB_DATA, SET_JOB_DETAIL_DATA } from "./action.types";

export const setJobs = (payload) => ({ type: SET_JOB_DATA, payload });

export const setJobDetail = (payload) => ({
  type: SET_JOB_DETAIL_DATA,
  payload,
});
